<template>
    <!-- S温馨提示 -->
    <div class="tip_wrapper" v-if="ifUserList == 0">
        <div v-if="!isHasAttention&&userDetail.collection&&userDetail.collection.follow==0">
            <div>你还没有关注任何人</div>
            <div>小助手给你推荐了以下有趣的小伙伴</div>
        </div>
        <div v-else>
            <div>暂无更多消息</div>
            <div>小助手给你推荐了以下有趣的小伙伴</div>
        </div>
    </div>
    <!-- O温馨提示 -->

    <div class="recommend_wrap" :style="{height: ifUserList == 0?'calc(100% - 75px)':'100%'}">
        <div class="scroll_wrapper">
            <div class="refresh_wrap">
                <span v-if="isRefreshing"><Loading color="#333" size="24px">加载中...</Loading></span>
                <span v-else>{{refreshTxt}}</span>
            </div>


            <!-- S推荐关注列表或者关注发布的文章 -->
            <div class="forum_wrapper" >
                <template v-if="ifUserList==0">
                    <div class="user_item" v-for="item in forumList" :key="item.user_id">
                        <User :userData='item' btnType="attention" :func="reqAttention" :cancelfunc="reqCancelAttention"></User>
                    </div>
                </template>
                <template v-if="ifUserList==1">
                    <div class="forum_item" v-for="item in forumList" :key="item.sub_forum_id" >
                        <Forum :isLikesFun="goLike" :forumData="item"></Forum>
                    </div>
                </template>
            </div>
            <!-- E推荐关注列表或者关注发布的文章 -->

            <empty-status v-if="forumList && forumList.length <= 0"></empty-status>

            <div class="refresh_bottom">{{refreshUptxt}}</div>
        </div>
    </div>

</template>

<script lang="js">
import { defineComponent, reactive, toRefs, onMounted, onActivated, computed,} from 'vue';
import router from "@/router"
import Util from '@/assets/js/lib/util';
import Forum from '@/components/Seven_Forum/Forum.vue';
import User from '@/components/Git_User/User.vue';
import BScroll from '@better-scroll/core'
import Pulldown from '@better-scroll/pull-down'
import Pullup from '@better-scroll/pull-up'
import ObserveImage from '@better-scroll/observe-image'
BScroll.use(Pullup)
BScroll.use(Pulldown)
BScroll.use(ObserveImage)
import { Swipe, SwipeItem, Loading,  } from "vant"
import EmptyStatus from "@/components/Seven_EmptyStatus/EmptyStatus.vue";

export default defineComponent({
    name: 'Recommend',
    components: {Swipe, SwipeItem, Loading, Forum, EmptyStatus, User},
    props: {
        name: {
            type: String,
            default: 'index'
        },
        userInfo: {
            type: Object
        }
    },
    setup(props) {
        const state = reactive({
            util: new Util(),
            bs: '',
            refreshUptxt: '加载更多',
            refreshTxt: '下拉刷新', //下拉刷新提示文字
            isRefreshing: false, //是否正在刷新中
            page: 1,
            total: 1,
            limit: 20,
            ifUserList: 0,
        });
        const data = reactive({
            forumList: [], //内容列表
            userDetail: {}, //用户详情
        });
        const isHasAttention = computed(()=>data.forumList.some(item=> item.is_atttention == true))
        const methods = {
            back: () => route.back(),
            goState: (o) => router.push(o),
            goLike: async (o) => {//点赞事件
                const res = await state.util.getJson('/thread/like', 'POST', o, true);
                if(res.code == 0){
                    await reqShamPraise(o);

                    setTimeout(() => {
                        state.bs.refresh();
                    }, 300);
                }else {
                    window.Components.toast(res.msg)
                }
            },
        }; //需要对外暴露的方法

        const reqShamPraise = async (params) => { //虚假更新点赞
            data.forumList.forEach((item,index) => {
                if(item.tid == params.tid){
                    data.forumList[index].user_like = params.status
                    if(data.forumList[index].user_like == 1){
                        data.forumList[index].likes += 1
                    }else{
                        data.forumList[index].likes -= 1
                    }
                }
            });
        };

        onMounted(async () => {
            if (new Util().Cookie().get("access_token")) {
                await reqForumList();
                await reqUserHome();
                initScroll();
            }
        });

        onActivated(async () => {
            if (new Util().Cookie().get("access_token")) {
                state.page = 1;
                await reqForumList();
                await reqUserHome();
                if(state.bs == ''){
                    initScroll();
                }else {
                    state.bs.refresh();
                }
            }
        })

        const initScroll = () => { //初始化上下滚动
            state.bs = new BScroll('.recommend_wrap',{
                scrollY: true,
                click: true,
                probeType: 2,
                bounceTime: 400,
                swipeBounceTime: 400,
                outOfBoundaryDampingFactor: 0.6,
                pullDownRefresh: {
                    threshold: 50,
                    stop: 40 //这样就会回到顶部了
                },
                pullUpLoad: { //上拉加载
                    threshold: -40
                },
                deceleration: 0.009,
                observeImage: true
            })

            state.bs.on('scroll',  (position) => {
                if(position.y < 38){
                    state.refreshTxt = '下拉刷新';
                    state.isRefreshing = false;
                    state.bs.finishPullDown();
                }else {
                    state.refreshTxt = '释放刷新'
                }
            });

            state.bs.on('pullingDown', async () => {

                state.isRefreshing = true;
                state.page = 1;
                state.total = 1;

                await reqForumList();
                await reqUserHome();

                setTimeout(() => {
                    window.Components.toast('刷新成功');
                    state.bs.finishPullDown();
                    state.bs.finishPullUp();
                }, 300);
            });

            state.bs.on('pullingUp', async () => {

                if(state.page > state.total){
                    state.refreshUptxt = '暂无更多数据';
                    return
                }
                state.refreshUptxt= '加载更多';

                await reqForumList(true);

                setTimeout(() => {
                    state.bs.finishPullUp();
                    state.bs.refresh();
                }, 300);
            });

            setTimeout(() => {
                state.bs.refresh();
            }, 100);
        };


        const reqForumList = async (flag = false) => { //请求列表
            const params = {
                page: state.page,
                per_page: state.limit
            }

            const res = await state.util.getJson('/thread/follow', 'GET', params, true);
            if(res.code == 0){
                if(flag){ //加载更多
                    if(res.data.thread.length == 0){
                        data.forumList.push(...res.data.recommendation);   //获取用户列表数据
                        state.ifUserList = 0
                    }else{
                        data.forumList.push(...res.data.thread);           //获取论坛列表数据
                        state.ifUserList = 1
                    }
                }else{ //刷新
                    if(res.data.thread.length == 0){
                        res.data.recommendation.forEach((item,index) =>{
                            res.data.recommendation[index].is_atttention = false
                        })
                        data.forumList = res.data.recommendation;         //获取用户列表数据
                        state.ifUserList = 0
                    }else{
                        data.forumList = res.data.thread;         //获取论坛列表数据
                        state.ifUserList = 1
                    }
                }

                state.page += 1;
                if(res.data.total > 1){
                    state.total = res.data.total;
                };
            }else {
                window.Components.toast(res.msg)
            }
        };

        const reqAttention = async (id) => { //请求关注然后虚假更新
            const stringId = id.toString()
            const params = {
                uid: stringId,
            }
            const res = await state.util.getJson('/user/follow', 'POST', params, true);
            if(res.code == 0){
                window.Components.toast('关注成功');
                shamUpdate(id)
                await reqUserHome();
                }else {
                window.Components.toast(res.msg)
            }
        };

        const shamUpdate = async (id) => {    //虚假更新
            data.forumList.forEach((item,index) => {
                if(item.user_id == id){
                    data.forumList[index].is_atttention = !data.forumList[index].is_atttention
                }
            });
        }

        const reqCancelAttention = async (id) => { //请求取消关注然后虚假更新
            const stringId = id.toString()
            const params = {
                uid: stringId,
            }
            const res = await state.util.getJson('/user/unfollow', 'POST', params, true);
            if(res.code == 0){
                window.Components.toast('取消关注成功');
                shamUpdate(id)
                await reqUserHome();
                }else {
                window.Components.toast(res.msg)
            }
        };

        const changeList = async () => { //局部刷新数据
            let params = {
                page: 1,
                per_page: state.limit * (state.page - 1 < 1 ? 1 : state.page - 1),
            }

            const res = await state.util.getJson('/thread/follow', 'GET', params, true);
            if(res.code == 0){
                if(res.data.thread.length == 0){
                    data.forumList = res.data.recommendation;         //获取用户列表数据
                    state.ifUserList = 0
                }else{
                    data.forumList = res.data.thread;         //获取论坛列表数据
                    state.ifUserList = 1
                }
                state.total = res.data.total;
            }else {
                window.Components.toast(res.msg)
            }
        };

        const reqUserHome = async () => {     //请求个人主页
                const res = await state.util.getJson('/user/home', 'GET', {uid: props.userInfo.user_id }, true);
                if(res.code == 0){
                    data.userDetail = res.data
                }else{
                    window.Components.toast(res.msg)
                }
        }

        return {
            ...toRefs(state),
            ...toRefs(data),
            ...methods,
            reqAttention,
            reqCancelAttention,
            isHasAttention
        };
    },
});
</script>
<style lang="less" scoped>
@charset "utf-8";
@import "./Attention.less";
</style>
